interface IBiometricsField {
  type?: string;
  value?: string;
}

export interface IBiometrics {
  eyes_color?: string;
  gender?: string;
  height?: IBiometricsField;
  overall_size?: IBiometricsField;
  shoes_size?: IBiometricsField;
  weight?: IBiometricsField;
}

export class Biometrics implements IBiometrics {
  eyes_color?: string;
  gender?: string;
  height?: IBiometricsField;
  overall_size?: IBiometricsField;
  shoes_size?: IBiometricsField;
  weight?: IBiometricsField;

  constructor( biometrics: IBiometrics = {} ) {
    this.eyes_color = biometrics.eyes_color;
    this.gender = biometrics.gender;
    this.height = biometrics.height || {};
    this.overall_size = biometrics.overall_size || {};
    this.shoes_size = biometrics.shoes_size || {};
    this.weight = biometrics.weight || {};
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/biometrics.ts